import { Component, OnInit, Input } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { ParticulierService } from "src/app/particulier/core/service/particulier.service";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { RetailItem } from "src/app/particulier/core/model/retail-item";
import { RetailItemService } from "src/app/particulier/core/service/retail-item.service";
import { AnalyseParticulier } from "src/app/particulier/core/model/analyse-particulier";
import { AnalyseParticulierService } from "src/app/particulier/core/service/analyse-particulier.service";
import { CorrectionHistoryService } from "src/app/mon-portefeuille/core/service/correction-history.service";
import { CorrectionHistory } from "src/app/mon-portefeuille/core/model/correction-history";
import { RetournerDossierModalComponent } from "src/app/formulaire/modal/retourner-dossier-modal/retourner-dossier-modal.component";
import { CorrigerDossier } from "src/app/mon-portefeuille/core/model/corriger-dossier";
import { EditCreditModalComponent } from "src/app/particulier/formulaire/modal/edit-credit-modal/edit-credit-modal.component";
import { UpdateFinanceIndividualComponent } from "src/app/formulaire/modal/particulier/update-finance-individual/update-finance-individual.component";
import { UpdateFinanceIndividual } from "src/app/parametrage/core/model/individual/update-finance-individual";
import { UpdateEmploiIndividualComponent } from "src/app/formulaire/modal/particulier/update-emploi-individual/update-emploi-individual.component";
import { UpdatePieceIndividualComponent } from "src/app/formulaire/modal/particulier/update-piece-individual/update-piece-individual.component";
import { UpdateInfoIndividualComponent } from "src/app/formulaire/modal/particulier/update-info-individual/update-info-individual.component";
import { ConditionRetail } from "src/app/particulier/core/model/condition-retail";
import { ConditionRetailService } from "src/app/particulier/core/service/condition-retail.service";
import { FormAddConditionComponent } from "src/app/particulier/formulaire/modal/form-add-condition/form-add-condition.component";
import { FormEditConditionComponent } from "src/app/particulier/formulaire/modal/form-edit-condition/form-edit-condition.component";

@Component({
  selector: "app-update-dossier-info",
  templateUrl: "./update-dossier-info.component.html",
  styleUrls: ["./update-dossier-info.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class UpdateDossierInfoComponent implements OnInit {
  form2: FormGroup;

  htmlContent = "";
  retournerDossier: String;

  corrigerDossier: CorrigerDossier;

  requestId: string;
  correctionId: string;

  dossier: Request;
  correctionHistory: CorrectionHistory;

  individual: Individual;
  facilites: RetailItem[];

  analyseParticulier: AnalyseParticulier;

  conditions: ConditionRetail[];
  conditionArray: Array<ConditionRetail[]> = [];
  displayedStudentsColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "actions",
  ];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    private _particulierService: ParticulierService,
    private _individualService: IndividualService,
    private _requestService: RequestService,
    private _retailItemService: RetailItemService,
    private _analyseParticulierService: AnalyseParticulierService,
    private _correctionHistoryService: CorrectionHistoryService,
    private _conditionService: ConditionRetailService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      check: [null, Validators.compose([Validators.required])],
      reponse: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.requestId = this._router.url.split("/")[3];
    this.correctionId = this._router.url.split("/")[4];

    this.getCorrectionHistoryById(this.correctionId);
    this.getRequestById(this.requestId);
    this.findCustomerByRequest(this.requestId);
    this.getListRetailItemByRequest(this.requestId);
    this.getAnalyseParticulierByrequestId(this.requestId);
  }

  getCorrectionHistoryById(correctionId) {
    this._correctionHistoryService
      .getCorrectionHistoryById(correctionId)
      .subscribe(
        (data) => {
          this.correctionHistory = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  findCustomerByRequest(requestId) {
    this._individualService.getIndividualByRequestId(requestId).subscribe(
      (data) => {
        this.individual = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListRetailItemByRequest(requestId) {
    this._retailItemService.getListRetailItemByRequest(requestId).subscribe(
      (data) => {
        this.facilites = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  updateCredit(retailItemId) {
    const modalRef = this.modalService.open(EditCreditModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.retailItemId = retailItemId;
    modalRef.componentInstance.workflowCode = this.dossier.workflow.code;

    modalRef.result.then(
      (data) => {
        // on close

        this.getCorrectionHistoryById(this.correctionId);
        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateFinance(individualId) {
    const modalRef = this.modalService.open(UpdateFinanceIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getCorrectionHistoryById(this.correctionId);
        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateEmploi(individualId) {
    const modalRef = this.modalService.open(UpdateEmploiIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updatePiece(individualId) {
    const modalRef = this.modalService.open(UpdatePieceIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateInfo(individualId) {
    const modalRef = this.modalService.open(UpdateInfoIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getConditionsByRequestItemId(requestitemid) {
    this._conditionService
      .getConditionRetailsByRetailItemId(requestitemid)
      .subscribe(
        (data) => {
          this.conditions = data;
          this.conditionArray[requestitemid] = this.conditions;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddCondition(requestItemId) {
    const modalRef = this.modalService.open(FormAddConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.retailItemId = requestItemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  EditCondition(conditionId, requestItemId) {
    const modalRef = this.modalService.open(FormEditConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.conditionId = conditionId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteCondition(conditionId, requestItemId) {
    this._conditionService
      .deleteConditionRetail(conditionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getConditionsByRequestItemId(requestItemId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getAnalyseParticulierByrequestId(requestId) {
    this._analyseParticulierService
      .getAnalyseParticulierByrequestId(requestId)
      .subscribe(
        (data) => {
          this.analyseParticulier = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  validUpdate(): void {
    this.corrigerDossier = new CorrigerDossier();
    this.corrigerDossier.correctionId = this.correctionId;
    this.corrigerDossier.reponse = this.htmlContent;

    this._correctionHistoryService
      .corriger(this.corrigerDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  retourner() {
    const modalRef = this.modalService.open(RetournerDossierModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestId = this.correctionHistory.request.id;

    modalRef.result.then(
      (data) => {
        // on close
        this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
